import React, { useState, useEffect } from 'react';
import { db } from "../firebase"; 
import { doc, setDoc, deleteDoc, serverTimestamp } from "firebase/firestore";

const AdminTracker = () => {
  const [tracking, setTracking] = useState(false);
  const [lastPos, setLastPos] = useState(null);
  const [error, setError] = useState(null);

  // Función para manejar el inicio/parada
  const handleToggleTracking = async () => {
    if (tracking) {
      // --- LÓGICA AL DETENER ---
      try {
        setTracking(false);
        setLastPos(null);
        // Borramos el documento para que el ciclista desaparezca de la web pública
        await deleteDoc(doc(db, "seguimiento", "francisco"));
        console.log("Documento eliminado. El marcador ha desaparecido de la web.");
      } catch (err) {
        console.error("Error al borrar el documento:", err);
      }
    } else {
      // --- LÓGICA AL INICIAR ---
      setTracking(true);
    }
  };

  useEffect(() => {
    let watchId = null;

    if (tracking) {
      watchId = navigator.geolocation.watchPosition(
        async (position) => {
          const { latitude, longitude, speed } = position.coords;
          const coords = { lat: latitude, lng: longitude };
          
          setLastPos(coords);
          setError(null);

          try {
            await setDoc(doc(db, "seguimiento", "francisco"), {
              lat: latitude,
              lng: longitude,
              velocidad: speed ? (speed * 3.6).toFixed(1) : 0,
              ultimaActualizacion: serverTimestamp(),
              activo: true
            });
          } catch (err) {
            console.error("Error al guardar en Firebase:", err);
            setError("Error al conectar con la base de datos");
          }
        },
        (err) => {
          setError(`Error de GPS: ${err.message}`);
          setTracking(false);
        },
        { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
      );
    }

    return () => {
      if (watchId) navigator.geolocation.clearWatch(watchId);
    };
  }, [tracking]);

  return (
    <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h2 style={{ color: '#3b203b' }}>Panel de Control de Seguimiento</h2>
      
      <div style={{
        margin: '20px auto',
        padding: '20px',
        border: '2px solid #e57be3',
        borderRadius: '15px',
        maxWidth: '400px',
        backgroundColor: tracking ? '#fff9ff' : '#f9f9f9'
      }}>
        <p style={{ fontSize: '1.2rem' }}>
            Estado: <strong>{tracking ? "🟢 EN VIVO" : "🔴 APAGADO"}</strong>
        </p>
        
        {lastPos ? (
          <p style={{ fontSize: '0.8rem', color: '#666' }}>
            Tu posición actual se está enviando...
          </p>
        ) : (
          <p style={{ fontSize: '0.8rem', color: '#999' }}>
            No hay datos de ubicación activos.
          </p>
        )}

        <button
          onClick={handleToggleTracking} // Usamos la nueva función
          style={{
            backgroundColor: tracking ? '#ff4d4d' : '#4CAF50',
            color: 'white',
            padding: '15px 30px',
            fontSize: '1.2rem',
            border: 'none',
            borderRadius: '10px',
            cursor: 'pointer',
            fontWeight: 'bold',
            marginTop: '10px',
            transition: '0.3s'
          }}
        >
          {tracking ? "DETENER Y LIMPIAR MAPA" : "INICIAR SEGUIMIENTO"}
        </button>

        {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
      </div>

      <div style={{ color: '#666', fontSize: '0.8rem', marginTop: '20px' }}>
        <p>Al detener, el marcador desaparecerá automáticamente de la web de Carmen.</p>
      </div>
    </div>
  );
};

export default AdminTracker;